import objectAssign from 'object-assign';
import initialState from './initialState';
import { 
  GET_PARKING_PRICE_REQUEST,
  GET_PARKING_PRICE_SUCCESS,
  GET_PARKING_PRICE_FAILURE,
  UPDATE_PRICE,
  GET_OFFERING_PRICE_REQUEST,
  GET_OFFERING_PRICE_SUCCESS,
  GET_OFFERING_PRICE_FAILURE,
  SET_SELECT_PRICING
 } from '../constants/actionTypes';

 export default function pricingReducer(state = initialState.pricing, action) {

    switch (action.type) {
      
      case GET_PARKING_PRICE_REQUEST:
        return objectAssign({}, state, { isLoading: true });
      case GET_PARKING_PRICE_FAILURE:
        return objectAssign({}, state, { isLoading: false, error: action.error});
      case GET_PARKING_PRICE_SUCCESS: {
        let data = action.data;
        return objectAssign({}, state, { isLoading: false, defaultPricingModel: data});
        
      }
      case GET_OFFERING_PRICE_REQUEST:
        return objectAssign({}, state, { isLoading: true });
      case GET_OFFERING_PRICE_FAILURE:
        return objectAssign({}, state, { isLoading: false, error: action.error});
      case GET_OFFERING_PRICE_SUCCESS: {
        let data = action.data;
        return objectAssign({}, state, { isLoading: false, dealPricingModel: data});
        
      }
      case UPDATE_PRICE:{
        return objectAssign({}, state, { isLoading: false, pricingModel: action.pricingModel});
      }
      case SET_SELECT_PRICING:{
        return objectAssign({}, state, { isLoading: false, pricingModel: action.pricingModel});
      }
      
          
      default:
        return state;
    }
  }


// WEBPACK FOOTER //
// ./src/reducers/pricingReducer.js